//====================================================
//  Function: Cart header
//====================================================
function componentCartHeader() {
  if ($(".navigation-buttons .cart-price").length) {
    $(".popup-widget.cart-widget .cart-widget-inner").before(
      '<div class="cart-header-text">' + basketHeaderTitle + "</div>"
    );

    var cartPrice = $(".navigation-buttons .cart-price");
    $(".popup-widget.cart-widget .cart-widget-inner").after(
      '<div class="cart-total"><div class="cart-total__text">' +
        basketHeaderSummary +
        "</div></div>"
    );
    cartPrice.insertAfter(
      ".popup-widget.cart-widget .cart-total .cart-total__text"
    );

    var cartSvg =
      '<svg class="icon-svg icon-cart"><use xlink:href="https://www.365121.myshoptet.' +
      lang +
      '/user/documents/public/images/sprites.svg#icon-cart"></use></svg><svg class="icon-svg icon-chevron-down"><use xlink:href="https://www.365121.myshoptet.' +
      lang +
      '/user/documents/public/images/sprites.svg#icon-chevron-down"></use></svg>';
    $(".navigation-buttons .cart-count").append(cartSvg);

    $(".popup-widget .cart-widget-button .btn").text(basketHeaderBtn);
  }
}
